import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      id: null,
      options: {}
    };

    this.confirm = this.confirm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  confirm = () => {
    this.props.onChange(this.state.id);
    this.toggle();
  };

  cancel = () => {
    this.props.onChange(false);
    this.toggle();
  };

  toggle(id, options) {
    this.setState({
      modal: !this.state.modal,
      id,
      options: options || {}
    });
  }

  render() {
    const {
      options: { title, body, buttonText, buttonClassName }
    } = this.state;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle}>
        <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
        <ModalBody className="text-center pb-2 pt-4">{body}</ModalBody>
        <ModalFooter>
          <button type="button" className={buttonClassName} onClick={this.confirm}>
            {buttonText}
          </button>
          <Button color="outline-primary" onClick={this.cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmationModal.js